import type React from 'react'
import { useTheme } from '../../hooks/useTheme'

interface TraderTeknoLogoProps {
  size?: 'sm' | 'md' | 'lg' | 'xl'
  variant?: 'default' | 'monochrome' | 'gradient' | 'minimal' | 'white'
  showText?: boolean
  className?: string
  /** Override img height with responsive Tailwind classes, e.g. "h-8 sm:h-10 lg:h-12" */
  imgClassName?: string
}

export const TraderTeknoLogo: React.FC<TraderTeknoLogoProps> = ({
  size = 'md',
  variant = 'default',
  showText: _showText = true,
  className = '',
  imgClassName
}) => {
  const { resolved } = useTheme()
  const sizeConfig = {
    sm: 'h-8',
    md: 'h-10',
    lg: 'h-12',
    xl: 'h-16'
  }

  const imgClass = imgClassName ?? sizeConfig[size]
  const invert = variant === 'monochrome' ? 'brightness-0' : ''

  // Use white logo in dark mode or when explicitly requested
  const useWhite = variant === 'white' || (variant !== 'monochrome' && resolved === 'dark')
  const logoSrc = useWhite ? '/logo-white.png' : '/logo-tradertekno.png'

  return (
    <div className={`flex items-center ${className}`}>
      <img
        src={logoSrc}
        alt="Trader Tekno"
        className={`${imgClass} w-auto ${invert}`}
      />
    </div>
  )
}

export const TraderTeknoMark: React.FC<{ size?: 'sm' | 'md' | 'lg'; className?: string }> = ({
  size = 'md',
  className = ''
}) => (
  <TraderTeknoLogo
    size={size}
    variant="minimal"
    showText={false}
    className={className}
  />
)

export default TraderTeknoLogo
